import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static targets = ['searchableItem', 'searchInput', 'hideWhenSearching', 'noResults']

    filter(event) {
        const query = (event.target.value || '').trim().toLowerCase()

        if (query.length === 0) {
            this.showAll()
            return
        }

        let hasVisibleItems = false

        // Show/hide items that match the query
        this.searchableItemTargets.forEach((element) => {
            const text = (element.textContent || '').trim().toLowerCase()
            const matches = text.includes(query)
            element.classList.toggle('d-none', !matches)

            if (matches) {
                hasVisibleItems = true
            }
        })

        // Hide headers or other elements while searching
        this.hideWhenSearchingTargets.forEach((element) => {
            element.classList.add('d-none')
        })

        // Show/hide "no results" message
        this.noResultsTarget.classList.toggle('d-none', hasVisibleItems)
    }

    showAll() {
        [...this.searchableItemTargets, ...this.hideWhenSearchingTargets].forEach((element) => {
            element.classList.remove('d-none')
        })
        this.noResultsTarget.classList.add('d-none')
    }
}
